const localesModules = import.meta.glob('/config/locales.json', {
  eager: true,
});

// @ts-ignore
export const localeOptions: LocaleOptions = Object.values(localesModules)[0]
  .default as LocaleOption[];

export const localeValues = localeOptions.map(
  (item: LocaleOption) => item.value
);

export const locales = [
  'de-DE',
  'en-US',
  'es-ES',
  'fr-FR',
  'it-IT',
  'pt-BR',
  'ar',
  'zh-CN',
  'zh-TW',
  'ja-JP',
  'ko-KR',
] as const;

export type Locales = (typeof locales)[number];

export const normalizeLocale = (locale?: string): string => {
  if (localStorage.getItem('locale')) {
    locale = localStorage.getItem('locale') as string;
    return locale;
  }

  try {
    if (!locale) {
      const language =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        //@ts-ignore
        navigator.userLanguage;
      locale = language?.split('-')[0] as string;

      // 切割语言，获取通用的语言

      if (locale === 'zh' && !language?.includes('zh-CN')) {
        return 'zh-TW';
      } else if (locale === 'ar') {
        return 'ar';

        // 确保匹配的事Value后面的值
        // 目前只开放en-US，es-ES，ja-JP，zh-CN，zh-TW
      } else if (JSON.stringify(localeOptions).includes(`"${locale}`)) {
        for (const l of localeOptions) {
          if (l.value.startsWith(locale)) {
            return l.value;
          }
        }
      } else {
        return 'en-US';
      }
    }
  } catch (e) {
    return 'en-US';
  }

  return 'en-US';
};
